module.exports = __webpack_public_path__ + "img/icon-remove-user.ba3da625.svg";